
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class DeviceOverviewInfoRow extends Vue {
    @Prop({ required: false, default: '' })
    title!: string;

    @Prop({ required: false, default: '' })
    value!: string | number;

    @Prop({ required: false, default: false })
    show!: boolean;

    @Prop({ required: false, default: false })
    loading!: boolean;
}
